import { loadGoogle } from '../common/help-functions'

export default async function () {
  const google = await loadGoogle()
  const markersArray = []
  const navLinks = document.querySelectorAll('.situation-map-section .step-btn')
  let centerMarker

  function getAddressCoordinates(address) {
    const geocoder = new google.maps.Geocoder()

    return new Promise((resolve, reject) => {
      geocoder.geocode({ address }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          resolve({
            latitude: results[0].geometry.location.lat(),
            longitude: results[0].geometry.location.lng(),
          })
        } else {
          reject(
            `Geocode was not successful for the following reason: ${status}`
          )
        }
      })
    })
  }

  function createMarker(location, map, title, snippet, zIndex) {
    return new Promise((resolve, reject) => {
      if (location.latitude !== undefined && location.longitude !== undefined) {
        const latLng = new google.maps.LatLng(
          location.latitude,
          location.longitude
        )

        resolve(placeMarker(latLng, map, title, snippet, zIndex))
      } else {
        const getMarkerCoordinates = getAddressCoordinates(location)

        getMarkerCoordinates.then(coordinates => {
          const latLng = new google.maps.LatLng(
            coordinates.latitude,
            coordinates.longitude
          )

          resolve(placeMarker(latLng, map, title, snippet, zIndex))
        })
      }
    })
  }

  function placeMarker(latLng, map, title, snippet, zIndex) {
    const infowindow = new google.maps.InfoWindow()

    snippet = `<div class="google-map-snippet-wrapper text-blue">
      <h5 class="">${title}</h5>
      ${snippet}
    </div>`

    const marker = new google.maps.Marker({
      position: latLng,
      title,
      map,
      snippet,
      zIndex, // Встановлюємо z-index
      icon: {
        url: '/assets/icons/marker.svg',
        size: new google.maps.Size(40, 40),
      },
    })

    if (snippet) {
      google.maps.event.addListener(marker, 'click', () => {
        infowindow.close()
        infowindow.setContent(snippet)
        infowindow.open(map, marker)
      })
    }

    markersArray.push(marker)

    return marker
  }

  function clearOverlays() {
    for (const marker of markersArray) {
      // Перевіряємо, чи це не центральний маркер перед видаленням
      if (marker !== centerMarker) {
        marker.setMap(null)
      }
    }
    markersArray.length = 0
  }

  function initMap() {
    const markersData = document.querySelector('.maps-data').dataset.json
    const mapZoom = +document.querySelector('.maps-data').dataset.zoom
    const mapCenter = document.querySelector('.maps-data').dataset.center
    const mapCenterMarker = document.querySelector('.maps-data').dataset.centerMarker
    const markers = JSON.parse(markersData)
    const centerCoordinates = getAddressCoordinates(mapCenter)

    centerCoordinates.then(coordinates => {
      const map = new google.maps.Map(
        document.getElementById('situation-map'),
        {
          center: new google.maps.LatLng(
            coordinates.latitude,
            coordinates.longitude
          ),
          zoom: mapZoom,
          styles: [
            {
              featureType: 'all',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#202c3e',
                },
              ],
            },
            {
              featureType: 'all',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  gamma: 0.01,
                },
                {
                  lightness: 20,
                },
                {
                  weight: '1.39',
                },
                {
                  color: '#c2c0c0',
                },
              ],
            },
            {
              featureType: 'all',
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  weight: '0.96',
                },
                {
                  saturation: '9',
                },
                {
                  visibility: 'on',
                },
                {
                  color: '#000000',
                },
              ],
            },
            {
              featureType: 'all',
              elementType: 'labels.icon',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'landscape',
              elementType: 'geometry',
              stylers: [
                {
                  lightness: 30,
                },
                {
                  saturation: '9',
                },
                {
                  color: '#29446b',
                },
              ],
            },
            {
              featureType: 'landscape',
              elementType: 'geometry.fill',
              stylers: [
                {
                  color: '#0c1137',
                },
              ],
            },
            {
              featureType: 'poi',
              elementType: 'geometry',
              stylers: [
                {
                  saturation: 20,
                },
              ],
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry',
              stylers: [
                {
                  lightness: 20,
                },
                {
                  saturation: -20,
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'all',
              stylers: [
                {
                  color: '#c2c0c0',
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [
                {
                  lightness: 10,
                },
                {
                  saturation: -30,
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'geometry.fill',
              stylers: [
                {
                  color: '#555c67',
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  saturation: 25,
                },
                {
                  lightness: 25,
                },
                {
                  weight: '0.01',
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'all',
              stylers: [
                {
                  lightness: -20,
                },
                {
                  color: '#515575',
                },
              ],
            },
          ],
        }
      )

      // Додавання статичного червоного маркера для центральної точки з великим z-index
      centerMarker = new google.maps.Marker({
        position: new google.maps.LatLng(
          coordinates.latitude,
          coordinates.longitude
        ),
        map,
        title: mapCenter,
        icon: {
          url: mapCenterMarker,
          size: new google.maps.Size(122, 100),
          scaledSize: new google.maps.Size(122, 100),
          anchor: new google.maps.Point(61, 75),
        },
        zIndex: 9999, // Встановлюємо високий z-index
      })

      markersArray.push(centerMarker)

      const createMarkerPromises = []

      for (const markerData of markers) {
        const zIndex = markerData.category === 'red' ? 9999 : 1 // Змінюємо z-index для червоного маркера
        const markerObj = createMarker(
          markerData.location,
          map,
          markerData.title,
          markerData.snippet,
          zIndex
        )

        createMarkerPromises.push(markerObj)
      }

      // Обробник подій для навігаційних посилань
      navLinks.forEach(link => {
        link.addEventListener('click', () => {
          navLinks.forEach(navLink => {
            navLink.classList.remove('active')
          })
          link.classList.add('active')
          const thisMarkerFilter = link.dataset.filter

          if (thisMarkerFilter !== '') {
            clearOverlays()
            markers.forEach(markerData => {
              if (markerData.category === thisMarkerFilter) {
                const zIndex = markerData.category === 'red' ? 9999 : 1
                const markerObj = createMarker(
                  markerData.location,
                  map,
                  markerData.title,
                  markerData.snippet,
                  zIndex
                )

                createMarkerPromises.push(markerObj)
              }
            })
          } else {
            markers.forEach(markerData => {
              const zIndex = markerData.category === 'red' ? 9999 : 1
              const markerObj = createMarker(
                markerData.location,
                map,
                markerData.title,
                markerData.snippet,
                zIndex
              )

              createMarkerPromises.push(markerObj)
            })
          }
        })
      })
    })

    const filterArray = []

    navLinks.forEach(link => {
      filterArray.push(link.dataset.filter)
    })

    filterArray.filter(item => {
      const thisItem = item

      if (thisItem !== '') {
        const items = markers.filter(marker => marker.category === thisItem)

        document.querySelector(
          `.situation-map-section .step-btn[data-filter="${thisItem}"] sup`
        ).textContent = items.length
      } else {
        document.querySelector(
          '.situation-map-section .step-btn[data-filter=""] sup'
        ).textContent = markers.length
      }
    })
  }

  initMap()
}
